var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.669,0C18.07,0,19.99,1.929,20,5.33v9.34c0,3.4-1.93,5.33-5.331,5.33H5.33C1.929,20,0,18.07,0,14.67V5.33C0,1.929,1.929,0,5.33,0ZM10.5,4.13a.84.84,0,0,0-1.281.79V15.11a.843.843,0,0,0,.83.75.827.827,0,0,0,.83-.75V4.92A.815.815,0,0,0,10.5,4.13ZM5.83,7.41a.823.823,0,0,0-.88,0,.841.841,0,0,0-.39.79v6.91a.834.834,0,0,0,1.659,0V8.2A.842.842,0,0,0,5.83,7.41Zm9.259,3.63a.839.839,0,0,0-.889,0,.806.806,0,0,0-.38.79v3.28a.827.827,0,0,0,.83.75.843.843,0,0,0,.83-.75V11.83A.834.834,0,0,0,15.089,11.04Z",
    transform: "translate(0 0)",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingIco);
export default __webpack_public_path__ + "static/media/tradingIco.7eb00cf82f24bcda5a3c143c88ee6e4c.svg";
export { ForwardRef as ReactComponent };